import React                from "react";
import ExtraChargesTable    from './ExtraChargesTable';

function ExtraChargesDetails({extraCharges, getTotal, erx}) {

  const statusLabel = {
    initial: 'New',
    pending_payment: 'Pending Payment',
    paid: 'Paid',
    cancelled: 'Cancelled',
    expired: 'Expired'
  }

  return (
    <div className="extra-charges-details">
      <h6 className="p-2">Status : <span className={erx.status}>{statusLabel[erx.status]}</span></h6>
      <ExtraChargesTable extraCharges={extraCharges} getTotal={getTotal}/>
    </div>
  );
}

export default ExtraChargesDetails;
